import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { CONVERSATIONS_ENDPOINT } from './constants';
import { TLeadChannelConversation } from './types';

/**
 * Most recent `WarboxConversation` of a lead in an area (by lead or by any
 * stored format of its phone), or null when it has none.
 */
export const getLeadChannelConversation = async (
    leadId: string,
    area: string
): Promise<TLeadChannelConversation> => {
    const response = await ApiV2.get(
        `${CONVERSATIONS_ENDPOINT.LEAD_CONVERSATION}/${leadId}`,
        { ...HEADERS(), params: { area } }
    );
    return response.data?.data || null;
};
